// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"dd2c64f1","239":"c89147f3","455":"bdb1ca70","557":"d548bf6a","762":"2bf66d1f"}[chunkId] + ".chunk.js";
};